import { default as _91slug_93eq6xNpjvHeMeta } from "/home/prod/v3/pages/blog/[slug].vue?macro=true";
import { default as indexZ59sqPyXZQMeta } from "/home/prod/v3/pages/blog/index.vue?macro=true";
import { default as indexgTwctIR7ThMeta } from "/home/prod/v3/pages/clubs/index.vue?macro=true";
import { default as _91slug_93gk5DE0yrGtMeta } from "/home/prod/v3/pages/football-trips/[slug].vue?macro=true";
import { default as indexFvuqyCCWDLMeta } from "/home/prod/v3/pages/gift-card/index.vue?macro=true";
import { default as indexHysiSjCUeJMeta } from "/home/prod/v3/pages/index.vue?macro=true";
import { default as _91slug_93cY5WvA1CDYMeta } from "/home/prod/v3/pages/info/[slug].vue?macro=true";
import { default as aboutFFYWkVBfTEMeta } from "/home/prod/v3/pages/info/about.vue?macro=true";
import { default as indexwgT4sEmTpCMeta } from "/home/prod/v3/pages/info/index.vue?macro=true";
import { default as professionGFtD16LanAMeta } from "/home/prod/v3/pages/info/profession.vue?macro=true";
import { default as _91slug_93G8B5NyX76tMeta } from "/home/prod/v3/pages/invoice/[slug].vue?macro=true";
import { default as _91slug_93xVNixzyuOOMeta } from "/home/prod/v3/pages/offer/[slug].vue?macro=true";
import { default as bookOzCghirn54Meta } from "/home/prod/v3/pages/packages/[slug]/book.vue?macro=true";
import { default as indexxj2wQzUwZrMeta } from "/home/prod/v3/pages/packages/[slug]/index.vue?macro=true";
import { default as preorderFF5Bme8rY7Meta } from "/home/prod/v3/pages/packages/[slug]/preorder.vue?macro=true";
import { default as _91slug_93b58tQsJjyTMeta } from "/home/prod/v3/pages/packages/[slug].vue?macro=true";
import { default as indexdygat3LpWFMeta } from "/home/prod/v3/pages/packages/index.vue?macro=true";
import { default as playgroundZYGlXTBLYIMeta } from "/home/prod/v3/pages/playground.vue?macro=true";
export default [
  {
    name: "blog-slug___da",
    path: "/blog/:slug()",
    component: () => import("/home/prod/v3/pages/blog/[slug].vue")
  },
  {
    name: "blog-slug___no",
    path: "/blog/:slug()",
    component: () => import("/home/prod/v3/pages/blog/[slug].vue")
  },
  {
    name: "blog-slug___sv",
    path: "/blog/:slug()",
    component: () => import("/home/prod/v3/pages/blog/[slug].vue")
  },
  {
    name: "blog___da",
    path: "/blog",
    component: () => import("/home/prod/v3/pages/blog/index.vue")
  },
  {
    name: "blog___no",
    path: "/blog",
    component: () => import("/home/prod/v3/pages/blog/index.vue")
  },
  {
    name: "blog___sv",
    path: "/blog",
    component: () => import("/home/prod/v3/pages/blog/index.vue")
  },
  {
    name: "clubs___da",
    path: "/klubber",
    component: () => import("/home/prod/v3/pages/clubs/index.vue")
  },
  {
    name: "clubs___no",
    path: "/klubber",
    component: () => import("/home/prod/v3/pages/clubs/index.vue")
  },
  {
    name: "clubs___sv",
    path: "/klubbar",
    component: () => import("/home/prod/v3/pages/clubs/index.vue")
  },
  {
    name: "football-trips-slug___da",
    path: "/fodboldrejser/:slug()",
    component: () => import("/home/prod/v3/pages/football-trips/[slug].vue")
  },
  {
    name: "football-trips-slug___no",
    path: "/fotballreiser/:slug()",
    component: () => import("/home/prod/v3/pages/football-trips/[slug].vue")
  },
  {
    name: "football-trips-slug___sv",
    path: "/fotbollsresor/:slug()",
    component: () => import("/home/prod/v3/pages/football-trips/[slug].vue")
  },
  {
    name: "gift-card___da",
    path: "/gavekort",
    component: () => import("/home/prod/v3/pages/gift-card/index.vue")
  },
  {
    name: "gift-card___no",
    path: "/gavekort",
    component: () => import("/home/prod/v3/pages/gift-card/index.vue")
  },
  {
    name: "gift-card___sv",
    path: "/presentkort",
    component: () => import("/home/prod/v3/pages/gift-card/index.vue")
  },
  {
    name: "index___da",
    path: "/",
    component: () => import("/home/prod/v3/pages/index.vue")
  },
  {
    name: "index___no",
    path: "/",
    component: () => import("/home/prod/v3/pages/index.vue")
  },
  {
    name: "index___sv",
    path: "/",
    component: () => import("/home/prod/v3/pages/index.vue")
  },
  {
    name: "info-slug___da",
    path: "/info/:slug()",
    component: () => import("/home/prod/v3/pages/info/[slug].vue")
  },
  {
    name: "info-slug___no",
    path: "/info/:slug()",
    component: () => import("/home/prod/v3/pages/info/[slug].vue")
  },
  {
    name: "info-slug___sv",
    path: "/info/:slug()",
    component: () => import("/home/prod/v3/pages/info/[slug].vue")
  },
  {
    name: "info-about___da",
    path: "/info/om-os",
    component: () => import("/home/prod/v3/pages/info/about.vue")
  },
  {
    name: "info-about___no",
    path: "/info/om-os",
    component: () => import("/home/prod/v3/pages/info/about.vue")
  },
  {
    name: "info-about___sv",
    path: "/info/om-oss",
    component: () => import("/home/prod/v3/pages/info/about.vue")
  },
  {
    name: "info___da",
    path: "/info",
    component: () => import("/home/prod/v3/pages/info/index.vue")
  },
  {
    name: "info___no",
    path: "/info",
    component: () => import("/home/prod/v3/pages/info/index.vue")
  },
  {
    name: "info___sv",
    path: "/info",
    component: () => import("/home/prod/v3/pages/info/index.vue")
  },
  {
    name: "info-profession___da",
    path: "/info/erhverv",
    component: () => import("/home/prod/v3/pages/info/profession.vue")
  },
  {
    name: "info-profession___no",
    path: "/info/virksomhet",
    component: () => import("/home/prod/v3/pages/info/profession.vue")
  },
  {
    name: "info-profession___sv",
    path: "/info/f%C3%B6retag",
    component: () => import("/home/prod/v3/pages/info/profession.vue")
  },
  {
    name: "invoice-slug___da",
    path: "/faktura/:slug()",
    meta: _91slug_93G8B5NyX76tMeta || {},
    component: () => import("/home/prod/v3/pages/invoice/[slug].vue")
  },
  {
    name: "invoice-slug___no",
    path: "/faktura/:slug()",
    meta: _91slug_93G8B5NyX76tMeta || {},
    component: () => import("/home/prod/v3/pages/invoice/[slug].vue")
  },
  {
    name: "invoice-slug___sv",
    path: "/faktura/:slug()",
    meta: _91slug_93G8B5NyX76tMeta || {},
    component: () => import("/home/prod/v3/pages/invoice/[slug].vue")
  },
  {
    name: "offer-slug___da",
    path: "/tilbud/:slug()",
    component: () => import("/home/prod/v3/pages/offer/[slug].vue")
  },
  {
    name: "offer-slug___no",
    path: "/tilbud/:slug()",
    component: () => import("/home/prod/v3/pages/offer/[slug].vue")
  },
  {
    name: "offer-slug___sv",
    path: "/tilbud/:slug()",
    component: () => import("/home/prod/v3/pages/offer/[slug].vue")
  },
  {
    name: _91slug_93b58tQsJjyTMeta?.name,
    path: "/packages/:slug()",
    component: () => import("/home/prod/v3/pages/packages/[slug].vue"),
    children: [
  {
    name: "packages-slug-book___da",
    path: "/pakker/:slug()/book",
    meta: bookOzCghirn54Meta || {},
    component: () => import("/home/prod/v3/pages/packages/[slug]/book.vue")
  },
  {
    name: "packages-slug___da",
    path: "/pakker/:slug()",
    component: () => import("/home/prod/v3/pages/packages/[slug]/index.vue")
  },
  {
    name: "packages-slug-preorder___da",
    path: "/pakker/:slug()/preorder",
    component: () => import("/home/prod/v3/pages/packages/[slug]/preorder.vue")
  }
]
  },
  {
    name: _91slug_93b58tQsJjyTMeta?.name,
    path: "/packages/:slug()",
    component: () => import("/home/prod/v3/pages/packages/[slug].vue"),
    children: [
  {
    name: "packages-slug-book___no",
    path: "/pakker/:slug()/book",
    meta: bookOzCghirn54Meta || {},
    component: () => import("/home/prod/v3/pages/packages/[slug]/book.vue")
  },
  {
    name: "packages-slug___no",
    path: "/pakker/:slug()",
    component: () => import("/home/prod/v3/pages/packages/[slug]/index.vue")
  },
  {
    name: "packages-slug-preorder___no",
    path: "/pakker/:slug()/preorder",
    component: () => import("/home/prod/v3/pages/packages/[slug]/preorder.vue")
  }
]
  },
  {
    name: _91slug_93b58tQsJjyTMeta?.name,
    path: "/packages/:slug()",
    component: () => import("/home/prod/v3/pages/packages/[slug].vue"),
    children: [
  {
    name: "packages-slug-book___sv",
    path: "/paket/:slug()/book",
    meta: bookOzCghirn54Meta || {},
    component: () => import("/home/prod/v3/pages/packages/[slug]/book.vue")
  },
  {
    name: "packages-slug___sv",
    path: "/paket/:slug()",
    component: () => import("/home/prod/v3/pages/packages/[slug]/index.vue")
  },
  {
    name: "packages-slug-preorder___sv",
    path: "/paket/:slug()/preorder",
    component: () => import("/home/prod/v3/pages/packages/[slug]/preorder.vue")
  }
]
  },
  {
    name: "packages___da",
    path: "/pakker",
    component: () => import("/home/prod/v3/pages/packages/index.vue")
  },
  {
    name: "packages___no",
    path: "/pakker",
    component: () => import("/home/prod/v3/pages/packages/index.vue")
  },
  {
    name: "packages___sv",
    path: "/paket",
    component: () => import("/home/prod/v3/pages/packages/index.vue")
  },
  {
    name: "playground___da",
    path: "/playground",
    component: () => import("/home/prod/v3/pages/playground.vue")
  },
  {
    name: "playground___no",
    path: "/playground",
    component: () => import("/home/prod/v3/pages/playground.vue")
  },
  {
    name: "playground___sv",
    path: "/playground",
    component: () => import("/home/prod/v3/pages/playground.vue")
  }
]